import React from 'react';

const Ontology = () => <div><h2>Ontology</h2></div>;

export default Ontology;
